import { useState, useEffect } from 'react';
import fnNoOp from 'lib/util/no-op';

function useWindowPosition() {
  const isBrowser = typeof window !== 'undefined'; // Check if window is defined

  const [position, setPosition] = useState({
    x: isBrowser ? window.scrollX : 0,
    y: isBrowser ? window.scrollY : 0,
  });

  useEffect(() => {
    if (!isBrowser) {
      return fnNoOp;
    }
    const handleScroll = () => {
      setPosition({ x: window.scrollX, y: window.scrollY });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isBrowser]);

  return position;
}

export default useWindowPosition;
